const ID_TOKEN_KEY = "id_token";
const ID_USER_KEY = "id_user";

export const getToken = () => {
  try {
    return window.localStorage.getItem(ID_TOKEN_KEY);
  } catch (error) {
    return null;
  }

};

export const saveToken = token => {
  try {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
  } catch (error) {
    return null;
  }
};

export const destroyToken = () => {
  try {
    window.localStorage.removeItem(ID_TOKEN_KEY);
  } catch (error) {
    return null;
  }
};


export const getUser = () => {
  try {
    return JSON.parse(window.localStorage.getItem(ID_USER_KEY));
  } catch (error) {
    return null;
  }

};

export const saveUser = user => {
  try {
    window.localStorage.setItem(ID_USER_KEY, JSON.stringify(user));
  } catch (error) {
    return null;
  }
};

export const destroyUser = () => {
  try {
    window.localStorage.removeItem(ID_USER_KEY);
  } catch (error) {
    return null;
  }
};

export default { getToken, saveToken, destroyToken, getUser, saveUser, destroyUser };
